import { type ChangeEvent, useState } from "react";

import { NumberInput } from "../../components/Form/formComponents/Number/NumberInput";
import { SelectInput } from "../../components/Select/SelectInput";
import { SelectInputMulti } from "../../components/Select/SelectInputMulti";
import { CheckboxInputStyle, InputTextHtmlStyle, InputTextStyle, SelectInputHtmlStyle, TextareaInputStyle } from "../styles/InputStyle";

const initialState = {
    input: "This is text",
    number: 42,
    textarea: "This is a textarea",
    select: "",
    multiselect: [] as string[],
    rotext: 23,
    checkbox: true,
};
export const InputDocs = () => {
    const [state, setState] = useState(initialState);

    function onChange(name: string, value?: string | string[] | number | boolean) {
        const currentState = { ...state };
        if (!name) {
            return;
        }
        // @ts-ignore
        currentState[name] = value;
        setState(currentState);
    }

    return (
        <>
            <div>
                <InputTextStyle
                    name="input"
                    value={state.input}
                    onChange={(ev: ChangeEvent<HTMLInputElement>) => onChange("input", ev.target.value)}
                    readOnly={false}
                />
                <InputTextStyle disabled value="This is a disabled input" name="input" readOnly />
                <TextareaInputStyle name="textarea" value={state.textarea} readOnly={false} />
                <TextareaInputStyle disabled name="textarea" value={`${state.textarea} disabled`} readOnly />
                <InputTextHtmlStyle
                    name="input"
                    value="This is an HTML text input"
                    onChange={(ev: ChangeEvent<HTMLInputElement>) => onChange(ev.target.name, ev.target.value)}
                />
            </div>
            <div>
                <NumberInput name="number" value={String(state.number)} onChange={(ev) => onChange("number", ev)} readOnly={false} />
                <NumberInput disabled name="number" value={String(state.number)} onChange={(ev) => onChange("number", ev)} readOnly />
            </div>
            <div>
                SelectInput AntD
                <SelectInput name="select" value={state.select} onChange={(v) => onChange("select", v)}>
                    <option value="a">Option A</option>
                    <option value="b">Option B</option>
                </SelectInput>
            </div>
            <div>
                Multiselect input AntD
                <SelectInputMulti name="multiselect" value={state.multiselect} onChange={(value) => onChange("multiselect", value)}>
                    <option value="a">Option A</option>
                    <option value="b">Option B</option>
                </SelectInputMulti>
            </div>
            <div>
                Disabled Select input AntD
                <SelectInput disabled value={state.select} onChange={(v) => onChange("select", v)} name="select">
                    <option value="a">Option A</option>
                    <option value="b">Option B</option>
                </SelectInput>
            </div>
            <div>
                Disabled Multiselect input AntD
                <SelectInputMulti disabled value={state.multiselect} name="multiselect">
                    <option value="a">Option A</option>
                    <option value="b">Option B</option>
                </SelectInputMulti>
            </div>
            <div>
                Select input HTML
                <SelectInputHtmlStyle>
                    <option value="a">Option A</option>
                    <option value="b">Option B</option>
                </SelectInputHtmlStyle>
            </div>
            <div>
                <CheckboxInputStyle
                    name="checkbox"
                    value={state.checkbox}
                    onChange={(ev: { target: { checked: string | number | boolean | string[] | undefined } }) =>
                        onChange("checkbox", ev.target.checked)
                    }
                />
            </div>
            <div>
                <CheckboxInputStyle name="checkbox" />
            </div>
        </>
    );
};
